import { render, staticRenderFns } from "./transFer.vue?vue&type=template&id=7a0773fc&scoped=true&"
import script from "./transFer.vue?vue&type=script&lang=js&"
export * from "./transFer.vue?vue&type=script&lang=js&"
import style0 from "./transFer.vue?vue&type=style&index=0&id=7a0773fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0773fc",
  null
  
)

export default component.exports